const TorHeader = ({
  title,
  details,
  img,
  color,
  reduceBottomOfTitle = false
}) => (
  <>
    <div className="grid grid-cols-1 lg:grid-cols-2">
      <div className="h-auto bg-blue">
        <div className={`lg:relative bg-${color}`}>
          <div className="pt-16 lg:pt-32 lg:text-left">
            <div className="px-4 pb-4 sm:px-16 sm:pb-16 xl:pr-16 max-w-auto ">
              <h1 className="text-4xl tracking-tight text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-8xl">
                <span className="block xl:inline">{title}</span>
              </h1>
            </div>
          </div>
        </div>
        <div className="lg:relative bg-blue">
          <div className="pb-16 lg:pb-32 lg:text-left">
            <div className="px-4 pt-4 sm:px-16 sm:pt-16 xl:pr-16 max-w-auto">
              <p className="mt-3 max-w-md text-white text-3xl sm:text-5xl md:mt-5 md:max-w-3xl">
                {details}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="h-full">
        <img
          className={`${
            reduceBottomOfTitle ? 'max-h-[750px]' : 'h-full"'
          } w-full object-cover object-top hidden lg:block`}
          src={img}
          alt=""
        />
      </div>
    </div>
  </>
)

export default TorHeader
